import React from 'react'
import "./glidar.css"
function Glidar({style, headerColor, content, title, animationDuration}) {
    return (
        <div style={{...style}} className='glidar'>
            {title && <div style={{background: headerColor}} className='header'>
                <h4>{title}</h4>
            </div>}
            <div className='slidar'>
                <div style={{animationDuration}} className='slidar-track'>
                
                    {
                        content?.map((item, index)=>(
                            <div key={index} className='silde-box'>
                        <img loading='lazy' className='silde-box-img' src={item} alt='client_img' />
                    </div>
                        ))
                    }
                    {
                        content?.map((item, index)=>(
                            <div  key={index} className='silde-box'>
                        <img loading='lazy' className='silde-box-img' src={item} alt='client_img' />
                    </div>
                        ))
                    }
                    

                    
                </div>
            </div>
        </div>
    )
}

export default Glidar